import { useMutation, useQueryClient } from "@tanstack/react-query";
import { format } from "date-fns";
import { errorLog } from "../../../logger";
import patchTaskV3 from "../../Tasks/requests/patchTask.v3";
import { genIdempotencyKey } from "../../utils/genIdempotencyKey";
import patchTransition from "../requests/patchTransition";
import { transitionDetailsKeyMaker } from "./useGetTransitionDetails";
import { transitionsKeyMaker } from "./useGetTransitions";
const transitionIdemDescriptor = "patch-transition";
const taskIdemDescriptor = "patch-task";
const dateFormat = "yyyy-MM-dd";
export default function useUpdateTransition(config) {
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: async ({ transitionId, request }) => {
            if (config === null) {
                throw new Error("No auth config");
            }
            try {
                // Separate task fields from transition fields
                const { launchDate, advisors, ...transitionRequest } = request;
                // 1. Update transition in Vanadium
                const transitionResult = await patchTransition(transitionId, transitionRequest, genIdempotencyKey(transitionIdemDescriptor), config);
                // 2. Update task with fields not supported by Vanadium (TaskServer)
                if (launchDate !== undefined) {
                    try {
                        const taskRequest = {
                            dueDate: format(new Date(launchDate), dateFormat),
                        };
                        await patchTaskV3(transitionResult.taskId, taskRequest, genIdempotencyKey(taskIdemDescriptor), config);
                    }
                    catch (error) {
                        // Log error but don't fail the entire operation since transition was already updated
                        errorLog("useUpdateTransition", `Failed to update task ${transitionResult.taskId}: ${error instanceof Error ? error.message : String(error)}`);
                    }
                }
                // TODO: Handle advisors field when supported by TaskServer
                if (advisors !== undefined) {
                    errorLog("useUpdateTransition", "Advisors field update not yet implemented - waiting for TaskServer support");
                }
                return transitionResult;
            }
            catch (error) {
                const errorMessage = "[useUpdateTransition] failed";
                errorLog(errorMessage, error instanceof Error ? error.message : String(error));
                throw error;
            }
        },
        onSuccess: (transition) => {
            queryClient.invalidateQueries({
                queryKey: transitionsKeyMaker(undefined),
            });
            queryClient.invalidateQueries({
                queryKey: transitionDetailsKeyMaker(transition.transitionId),
            });
        },
    });
    return mutation.mutateAsync;
}
//# sourceMappingURL=useUpdateTransition.js.map